import { ConditionEnum } from '@app/base/enum/condition.enum';
import { isArray } from 'util';

export class ConditionSearchList {

    private conditions: Object[] = [

        { 'condition': [ConditionEnum.String, ConditionEnum.Numerico, ConditionEnum.Data, ConditionEnum.Money], 'id': 0, 'descricao': 'Igual' },
        { 'condition': ConditionEnum.String, 'id': 1, 'descricao': 'Contenha' },
        { 'condition': ConditionEnum.String, 'id': 2, 'descricao': 'Não Contenha' },
        { 'condition': [ConditionEnum.Numerico, ConditionEnum.Data, ConditionEnum.Money], 'id': 3, 'descricao': 'Maior ou igual' },
        { 'condition': [ConditionEnum.Numerico, ConditionEnum.Data, ConditionEnum.Money], 'id': 4, 'descricao': 'Maior que' },
        { 'condition': [ConditionEnum.Numerico, ConditionEnum.Data, ConditionEnum.Money], 'id': 5, 'descricao': 'Menor ou igual' },
        { 'condition': [ConditionEnum.Numerico, ConditionEnum.Data, ConditionEnum.Money], 'id': 6, 'descricao': 'Menor que' },
        { 'condition': [ConditionEnum.Numerico, ConditionEnum.Data, ConditionEnum.Money], 'id': 7, 'descricao': 'Entre' },
        { 'condition': ConditionEnum.String, 'id': 8, 'descricao': 'Comece com' },
        { 'condition': ConditionEnum.String, 'id': 9, 'descricao': 'Termine com' },

        { 'condition': ConditionEnum.Situacao, 'id': 0, 'descricao': 'Inativo' },
        { 'condition': ConditionEnum.Situacao, 'id': 1, 'descricao': 'Ativo' },

        { 'condition': ConditionEnum.Bool, 'id': 0, 'descricao': 'Não' },
        { 'condition': ConditionEnum.Bool, 'id': 1, 'descricao': 'Sim' },

        { 'condition': ConditionEnum.TipoEntradaSaida, 'id': 0, 'descricao': 'Entrada' },
        { 'condition': ConditionEnum.TipoEntradaSaida, 'id': 1, 'descricao': 'Saída' },

        { 'condition': ConditionEnum.NivelAcesso, 'id': 1, 'descricao': 'Diocesano' },
        { 'condition': ConditionEnum.NivelAcesso, 'id': 2, 'descricao': 'Neste organismo' },
        { 'condition': ConditionEnum.NivelAcesso, 'id': 3, 'descricao': 'Organismo especifico' },

        { 'condition': ConditionEnum.Tipo, 'id': 0, 'descricao': 'Caixa' },
        { 'condition': ConditionEnum.Tipo, 'id': 1, 'descricao': 'Banco' },

        { 'condition': ConditionEnum.TipoPessoa, 'id': 1, 'descricao': 'Física' },
        { 'condition': ConditionEnum.TipoPessoa, 'id': 2, 'descricao': 'Jurídica' },

        { 'condition': ConditionEnum.Destino, 'id': 0, 'descricao': 'Ativo' },
        { 'condition': ConditionEnum.Destino, 'id': 1, 'descricao': 'Passivo' },
        { 'condition': ConditionEnum.Destino, 'id': 2, 'descricao': 'Receita' },
        { 'condition': ConditionEnum.Destino, 'id': 3, 'descricao': 'Despesa' },
        { 'condition': ConditionEnum.Destino, 'id': 4, 'descricao': 'Transitório' },

    ];

    public get(condition: ConditionEnum): Object[] {
        return this.conditions.filter((filter) => {
            if (isArray(filter['condition'])) {
                return filter['condition'].includes(condition);
            }

            return filter['condition'] === condition;
        });
    }

    public getDefault(condition: ConditionEnum): any {
        switch (condition) {
            case ConditionEnum.String:
                return 1;
            case ConditionEnum.Situacao:
                return 1;
            case ConditionEnum.NivelAcesso:
                return 1;
            case ConditionEnum.Tipo:
                return 1;
            case ConditionEnum.TipoPessoa:
                return 1;
            default:
                return 0;
        }
    }
}

/*
Enum do eclesialweb
public enum Conditions
    {
        Equals = 0,
        Contains = 1,
        NotContains = 2,
        GreaterThanOrEqual = 3,
        GreaterThan = 4,
        LessThanOrEqual = 5,
        LessThan = 6,
        StartsWith = 7,
        EndsWith = 8,
        NotEquals = 9,
        IsNull = 10,
        IsNotNull = 11,
        GreaterThanOrEqualOrNull = 12,
        LessThanOrEqualOrNull = 13,
        GreaterThanOrNull = 14,
        LessThanOrNull = 15,
        EqualsOrNull = 16,

    }
*/